import { useState, FC } from 'react';
import Highlight from 'react-highlight/lib/optimized';
import { DashboardJson } from '../../models';
import { Formatter } from './models';
import { DashboardSourceCodeTab } from './DashboardSourceCodeTab';
import { transformDashboard } from '../../../utils';

const FORMATTERS: Formatter[] = [Formatter.YAML, Formatter.JSON];

export interface DashboardSourceCodeProps {
  className?: string;
  dashboard: DashboardJson;
}

export const DashboardSourceCode: FC<DashboardSourceCodeProps> = ({ className = '', dashboard }) => {
  const [formatter, setFormatter] = useState<Formatter>(Formatter.YAML);
  const code = transformDashboard(dashboard, formatter);

  return (
    <div className={`w-0 ${className}`}>
      <div>
        {FORMATTERS.map(formatterType => (
          <DashboardSourceCodeTab
            key={formatterType}
            activeFormatter={formatter}
            setFormatter={setFormatter}
            formatter={formatterType}
          />
        ))}
      </div>
      <div className="flex-1 overflow-auto">
        <Highlight languages={['json']} className="json text-sm">
          {code}
        </Highlight>
      </div>
    </div>
  );
};
